import { useRef, useEffect } from 'react';
import useScrollListener from '../../hooks/useScrollListener'; 

import HomeHeader from '../../components/home-header/home-header.component';
import TextAndImage from '../../components/text-and-image/text-and-image.component';

import ContactFormBox from '../../components/contact-box/contact-box.component';

import txtimage1 from '../../jpeg/pages/launch-store/44.jpg';
import txtimage2 from '../../jpeg/pages/launch-store/11.jpg';

import Footer from '../../components/footer/footer.component';

import bgImage from '../../jpeg/pages/launch-store/33.jpg';
import { HomePageContainer } from './launch-store.styles';

const LaunchStorePage = ({ onScroll }) => {
	const contentRef = useScrollListener(onScroll);
	const contactRef = useRef(null); // Ref for Contact section

	const scrollToContact = () => {
		// Smoothly scroll to the Contact section
		if (contactRef.current) {
			contactRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	};

	// Check for scroll flag in sessionStorage on load
	useEffect(() => {
		if (sessionStorage.getItem('scrollToContact') === 'true') {
			scrollToContact();
			sessionStorage.removeItem('scrollToContact'); // Reset the flag after scrolling
		}
	}, []);

	// Handler to set scroll flag and refresh page
	// const refreshAndScroll = () => {
	// 	sessionStorage.setItem('scrollToContact', 'true'); // Set flag to scroll after refresh
	// 	window.location.reload(); // Refresh the page
	// };

	const textAndImage1 = {
		img: txtimage1,
		title: "Premium Quality",
		text: "Get a store built with the highest standards, designed to perform and impress. We don’t just create websites; we create experiences that keep customers coming back.",
		title2: "A Store That Grows with You",
		text2: "Designed for scalability, your store will be ready to handle all your future growth. As your business expands, your website will keep up every step of the way.",
	};

	const textAndImage2 = {
		img: txtimage2,
		title: "Save Time with Expert Support",
		text: "Experience swift results! Your store will be operational within just 7 business days, ensuring a fast-track to launching your e-commerce business.",
		title2: "Crafted for Success in Every Detail",
		text2: "We know what works in e-commerce. Every store we build is crafted to succeed, from its design and layout to its functionality and marketing.",
		txtL: true,
	};

	return (
		<HomePageContainer ref={contentRef}>
			<div className='home-scroll'>
				<HomeHeader 
					title="Launch Your Dream Store with Ease"
					btnText="Hire Us"
					bgImage={bgImage}
					whatToDO={scrollToContact} 
				/>

				<div className='text-and-image-box'>
					<TextAndImage 
						img={textAndImage1.img} 
						title={textAndImage1.title} 
						text={textAndImage1.text}
						title2={textAndImage1.title2} 
						text2={textAndImage1.text2}
						txtL={textAndImage1.txtL}
					/>
					<TextAndImage 
						img={textAndImage2.img} 
						title={textAndImage2.title} 
						text={textAndImage2.text}
						title2={textAndImage2.title2} 
						text2={textAndImage2.text2}
						txtL={textAndImage2.txtL}
					/>
				</div>

				<div ref={contactRef}>
					<ContactFormBox whatContactForm={<div class="klaviyo-form-R3vFLg"></div>} />
				</div>
				
			</div>

			<Footer />
		</HomePageContainer>
	);
}

export default LaunchStorePage;
